<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { PaginationListItem, type PaginationListItemProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from "@/shared/components/ui/button";

const props = defineProps<
  PaginationListItemProps & {
    class?: HTMLAttributes["class"];
  }
>();
</script>

<template>
  <PaginationListItem
    v-bind="props"
    :class="
      cn(
        buttonVariants({
          variant: 'ghost',
          size: 'icon',
        }),
        'data-[selected=true]:border-2 data-[selected=true]:border-zinc-900 data-[selected=true]:bg-transparent data-[selected=true]:text-zinc-900 data-[selected=true]:font-medium',
        props.class,
      )
    "
  >
    <slot />
  </PaginationListItem>
</template>
